module.exports = __webpack_public_path__ + "img/card_3.7c3dd3af.png";